(() => {
  'use strict';
  document.querySelectorAll('[data-spring-countdown]').forEach((bar) => {
    if (bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    const end = Date.parse(bar.dataset.deadline);
    let timer;
    const hours = bar.querySelector('[data-spring-hours]');
    const minutes = bar.querySelector('[data-spring-minutes]');
    const seconds = bar.querySelector('[data-spring-seconds]');
    const update = () => {
      clearTimeout(timer);
      const remaining = end - Date.now();
      if (!Number.isFinite(end) || remaining <= 0) {
        bar.hidden = true;
        return;
      }
      const total = Math.ceil(remaining / 1000);
      hours.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor(total / 60) % 60).padStart(2, '0');
      seconds.textContent = String(total % 60).padStart(2, '0');
      if (!document.hidden) timer = setTimeout(update, 1000);
    };
    update();
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
  });
})();
